import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APPS = {
  aluno: { m: "/manifest.webmanifest", i: "/icons/aluno-v1-apple-touch-180.png", t: "AF Aluno" },
  gestao: { m: "/admin-manifest.webmanifest", i: "/icons/admin-v4-apple-touch-180.png", t: "AF Gestão" },
};

// Mantém manifest/ícone/título do app certo a cada troca de tela (SPA).
export const PwaHeadSync = () => {
  const location = useLocation();
  useEffect(() => {
    const p = window.location.pathname;
    if (p.startsWith("/totem") || p.startsWith("/autocadastro")) return;
    const cfg = p.startsWith("/portal") ? APPS.aluno : APPS.gestao;
    const m = document.querySelector('link[rel="manifest"]');
    if (m && m.getAttribute("href") !== cfg.m) m.setAttribute("href", cfg.m);
    document.querySelectorAll('link[rel="apple-touch-icon"]').forEach((l) => l.setAttribute("href", cfg.i));
    const t = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (t) t.setAttribute("content", cfg.t);
  }, [location.pathname]);
  return null;
};
